import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {deleteUserBySuperAdmin} from "../../../services/users-service";
import {errorlog} from "../../../utils";
import React from "react";
import ActionButton from "../../save-button";
import {deleteOrganizzations} from "../../../business-logic/organizzations";


export const DeleteOrganizzationPrompt = props => (
    <Modal isOpen={ true } toggle={toggleEvent => props.onClose()}>
        <ModalHeader toggle={toggleEvent => props.onClose()} className={ "modal-colored-header bg-danger" }>
            ATTENZIONE
        </ModalHeader>
        <ModalBody>
            Sicuro di eliminare l'organizzazione { props.org.name }
        </ModalBody>
        <ModalFooter>
            <ActionButton
                color={"link"}
                buttonText={"annulla"}
                promise={ () => {
                    return Promise.resolve();
                }}
                onResult={  toggleEvent => props.onClose() }
            />

            <ActionButton
                buttonText={"Elimina"}
                color={"danger"}
                promise={ () => {
                    return deleteOrganizzations( props.org.id );
                }}
                onResult={ result => {
                    props.onClose( true );
                }}
                onError={ e => {
                    if( typeof e === "string" && !!e && e.trim().length > 0 ) {
                        props.onDenied( e );
                    }
                    else {
                        errorlog("errore all'eliminazione di un organizzazione", e);
                        props.onClose()
                    }
                }}
            />
        </ModalFooter>
    </Modal>
);
